require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/fn/object/assign.js